export default __webpack_public_path__ + "static/media/filter.769b1bb3.png";